module.exports = __webpack_public_path__ + "static/media/database.ad48bf75.svg";